import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Table, TableProvider, useTableState } from '@optimus-web/core';
import { Bill } from '@mews-commander/data-access';
import { fetchAccountsByBillIds } from '@mews-commander/legacy-entities/src/actions/accounts';
import { useColumns } from './tableMapping';

interface BillTableProps {
    bills: Array<Bill>;
    refetch: () => void;
    billOwnerId: string;
    isLoading: boolean;
}

export const BillTableNew = ({ bills, refetch, billOwnerId, isLoading }: BillTableProps) => {
    const [tableState, setTableState] = useTableState<Bill>({ pagination: { show: false } });
    const columns = useColumns({ refetch, billOwnerId });
    const dispatch = useDispatch();

    useEffect(() => {
        const billIds = bills.map((billItem: Bill) => billItem.id);
        dispatch(fetchAccountsByBillIds({ billIds }));
    }, [bills, dispatch]);

    return (
        <TableProvider state={tableState} onStateChange={setTableState} columns={columns}>
            <Table uniqueRowId="id" data={bills} amountOfRows={bills.length} loading={isLoading} />
        </TableProvider>
    );
};
